module.exports = __webpack_public_path__ + "img/icon-room-cloakroom.af9e1e85.svg";